import React from "react";
import { withStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, DialogTitle, Grid, DialogActions, Button}from "@material-ui/core";
import styles from "./ModalStyle";
const AddRouteToLassoModal = props => {
    const { classes }=  props;
    return (
        <Dialog
        open={true}
        aria-labelledby="AddRouteToLassoModal-title"
        classes = {{paper: classes.dialog}}
        maxWidth= 'sm'
    >
        <DialogTitle id="AddRouteToLassoModal-title" classes={{root: classes.dialogTitle}} disableTypography >
            { props.isAlreadySelected ? "Remove route from lasso" : "Add route to lasso" }
        </DialogTitle>
        <DialogContent  classes={{root:classes.dialogContent}}>
            <Grid container spacing={24}>
                <Grid item xs={12} classes={{root: classes.message}}>
                    Are you sure you want to { props.isAlreadySelected ? `remove route ${props.routeName} from map for lasso selection?` : `add route ${props.routeName} to map for lasso selection?`}
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions classes={{root: classes.dialogAction}}>
            <Grid container spacing={24}>
                <Grid item xs={4}></Grid>
                <Grid item xs={8} classes={{item: classes.lassoDialogAction}}>
                    <Button
                        variant="outlined"
                        color="primary"
                        size="medium"
                        className={classes.button}
                        onClick={props.onClose}>
                            Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size="medium"
                        disableRipple
                        className={classes.button}
                        onClick={props.onConfirm}>
                            Confirm
                    </Button>
                </Grid>
            </Grid>
    </DialogActions>
    </Dialog>
    )
}

export default withStyles(styles)(AddRouteToLassoModal);